import axios from 'axios';

import { SAUDAGAR_OUTLETS_ME } from './constant';

export function getSaudagarOutletDetail(goBizAccessToken) {
  const bearer = `Bearer ${goBizAccessToken}`;
  return axios
    .get(SAUDAGAR_OUTLETS_ME, {
      headers: {
        Authorization: bearer,
      },
    })
    .catch((error) => {
      if (error?.response?.data?.error) {
        return Promise.reject(new Error(error.response.data.error));
      }
      return Promise.reject(error);
    });
}
